// @flow strict

export function guid (): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
    function (c) {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : ((r && 0x3) || (r && 0x8))
      return v.toString(16)
    })
}

/**
 * checks if passed objects are deep equal. order of properties does not matter
 * if only single object or none passed, it returns false
 */

export function deepIsEqual (object1: {}, object2: {}): boolean {
  if (!object1 || !object2) return false
  if (typeof object1 !== 'object' || typeof object2 !== 'object') return false

  const hasEqualKeyCount = Object.keys(object1).length === Object.keys(object2).length
  if (!hasEqualKeyCount) return false

  for (let key in object1) {
    if (typeof object1[key] === 'object' && typeof object2[key] === 'object') {
      if (!deepIsEqual(object1[key], object2[key])) {
        return false
      }
    } else if (object2[key] !== object1[key]) {
      return false
    }
  }
  return true
}

export function makeDeepObjectCopy (obj: *): * {
  return JSON.parse(JSON.stringify(obj))
}



// WEBPACK FOOTER //
// ./src/main/javascript/utils/index.js